import React, { useState } from "react";
import clsx from "clsx";
import { CloseIcon } from "../Icon";
import { getTailwindColorClass, Intent } from "lib/common/enums";

interface infoProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  variant?: Intent;
  closeButton?: boolean;
  children: React.ReactNode;
}

function InfoStrip({
  className,
  variant,
  children,
  closeButton = false,
}: infoProps) {
  const [showInfo, setShowInfo] = useState(true);

  return !showInfo ? null : (
    <div
      className={clsx(
        className,
        ` ${
          variant
            ? `bg-${getTailwindColorClass(variant)}-300`
            : "bg-success-300"
        }`
      )}
    >
      <div className="container mx-auto flex items-center justify-between pl-4 pr-10 py-5">
        <span className="flex-1">{children}</span>
        {closeButton && (
          <span
            className="cursor-pointer hover:bg-gray-500 hover:bg-opacity-20 p-1"
            onClick={() => setShowInfo(false)}
          >
            <CloseIcon color="#304254" size={5} />
          </span>
        )}
      </div>
    </div>
  );
}

export default InfoStrip;
